export const COMMENT_LABEL_OPTIONS = [
  { value: "note", label: "Note" },
  { value: "call", label: "Call" },
  { value: "email", label: "Email" },
  { value: "meeting", label: "Meeting" },
  { value: "internal_screening", label: "Internal Screening" },
  { value: "client_interview_notes", label: "Client Interview Notes" },
  { value: "client_feedback", label: "Client Feedback" },
  { value: "general_update", label: "General Update" },
  { value: "phone_call", label: "Phone Call" },
  { value: "text_message", label: "Text Message" },
] as const

export type CommentLabel = (typeof COMMENT_LABEL_OPTIONS)[number]["value"]

export const getCommentLabel = (value: string) =>
  COMMENT_LABEL_OPTIONS.find((option) => option.value === value)?.label ?? value
